import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
    DatabaseOutlined,
    HomeOutlined,
    MessageOutlined,
    RobotOutlined,
    ScanOutlined,
    ShoppingOutlined,
    StarOutlined,
} from '@ant-design/icons';
import { unlockScannerAudio } from '../Scanner/scannerAudio';
import './MobileBottomNav.css';

const ITEMS = [
    {
        label: 'Главное',
        path: '/dashboard',
        icon: HomeOutlined,
        matches: (pathname) => pathname === '/dashboard' || pathname === '/',
    },
    {
        label: 'Остатки',
        path: '/stocksm',
        icon: DatabaseOutlined,
        matches: (pathname) => pathname === '/stock' || pathname === '/stocksm',
    },
    {
        label: 'Заказы',
        path: '/orders/ozonm',
        icon: ShoppingOutlined,
        matches: (pathname) => pathname.startsWith('/orders/ozon'),
    },
    {
        label: 'Сканер',
        path: '/scanner',
        icon: ScanOutlined,
        matches: (pathname) => pathname.startsWith('/scanner'),
    },
    {
        label: 'GPT',
        path: '/bananas-gpt/openrouter',
        icon: RobotOutlined,
        matches: (pathname) => pathname.startsWith('/bananas-gpt'),
    },
    {
        label: 'Отзывы',
        path: '/reviews',
        icon: StarOutlined,
        matches: (pathname) => pathname.startsWith('/reviews'),
    },
    {
        label: 'Сообщения',
        path: '/messages',
        icon: MessageOutlined,
        matches: (pathname) => pathname.startsWith('/messages'),
    },
];

const MobileBottomNav = () => {
    const { pathname } = useLocation();

    return (
        <nav className="mobile-bottom-nav" aria-label="Основная навигация">
            <div className="mobile-bottom-nav__surface">
                {ITEMS.map((item) => {
                    const Icon = item.icon;
                    const active = item.matches(pathname);

                    return (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            onPointerDown={
                                item.path === '/scanner' ? unlockScannerAudio : undefined
                            }
                            className={`mobile-bottom-nav__item${
                                active ? ' mobile-bottom-nav__item--active' : ''
                            }`}
                            aria-current={active ? 'page' : undefined}
                        >
                            <span className="mobile-bottom-nav__icon">
                                <Icon />
                            </span>
                            <span className="mobile-bottom-nav__label">{item.label}</span>
                        </NavLink>
                    );
                })}
            </div>
        </nav>
    );
};

export default MobileBottomNav;
